const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-TabularTemplate-Group-Prefix',
			DefaultInputExtensions: [ 'Bulma-TableControls' ],
			Template: /*HTML*/`
			<!-- Form Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" class="{~D:Record.CSSClass~}" {~D:Record.Macro.PictFormLayout~}>
				<h3 class="section-subheader has-border {~ShowGroupTitle:Record~}" data-i-group-hash="{~D:Record.Hash~}">{~D:Record.Name~}</h3>
				<div class="section-table-wrapper mb-2 {~HideTableControls:Record~}">
					<!-- Opt-in top add bar (Group.EntryControls.Position 'top'/'both'); renders nothing otherwise -->
					{~EntryAddBarTop:Record~}
					<div id="TABLE-WRAPPER-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}" class="table-container"
						onscroll="_Pict.providers['Bulma-TableControls'].updateSliderFromScrollTableEvent('{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}', event)">
						<table id="TABLE-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}" class="table is-fullwidth is-hoverable">`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-Prefix',
			Template: /*HTML*/`
							<thead>
								<tr>
									{~T:TabularTemplateRowHeader-ExtraPrefix~}`,
		},
		{
			HashPostfix: '-TabularTemplate-HeaderCell',
			Template: /*HTML*/`
									<!-- Descriptor {~D:Record.Name~} [{~D:Record.Hash~}] -> {~D:Record.Address~} -->
									<th data-tabular-column-index="{~D:Record.PictForm.InputIndex~}" class="{~HiddenInputTabularAdjustment:Record~}">
										<span class="label {~HideLabel:Record~}">{~LabelWithChips:Record:TabularLabel~}</span>
										{~UnitsTabularHeader:Record~}
									</th>`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-ExtraPrefix',
			Template: /*HTML*/`
									<!-- TabularTemplateRowHeader-ExtraPrefix -->`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-ExtraPostfix',
			Template: /*HTML*/`
									<!-- TabularTemplateRowHeader-ExtraPostfix -->
									<th class="extra-table-column" data-table-controls="menu"></th>`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-Postfix',
			Template: /*HTML*/`
									{~T:TabularTemplateRowHeader-ExtraPostfix~}
								</tr>
							</thead>
							<tbody>`,
		},
		/*
		 * BEGIN Tabular Template Extra Header Rows
		 * Used for stacked/clustered headers (the Group's `Headers` config).
		 * Each entry in Headers is one ADDITIONAL header row stacked above the
		 * default column-name row. Cells carry { Label, ColumnSpan, CSSClass }.
		 */
		{
			'HashPostfix': '-TabularTemplate-ExtraHeaderRow-Prefix',
			'Template': /*HTML*/`
								<tr class="pict-tabular-extra-header-row">`,
		},
		{
			'HashPostfix': '-TabularTemplate-ExtraHeaderRow-Postfix',
			'Template': /*HTML*/`
								</tr>`,
		},
		{
			'HashPostfix': '-TabularTemplate-ExtraHeaderCell',
			'Template': /*HTML*/`
									<th colspan="{~D:Record.ColumnSpan~}" class="pict-tabular-extra-header-cell {~D:Record.CSSClass~}">{~D:Record.Label~}</th>`,
		},
		/*
		 * END Tabular Template Extra Header Rows
		 */

		/*
		 * BEGIN Tabular Template Row Label Columns
		 * Used for left-side label columns (the Group's `RowLabels` config).
		 * Header cell renders one <th> per RowLabels entry. Per-row cell renders
		 * one <td> per RowLabels entry; rowspans collapse consecutive equal
		 * values when `Cluster: true`. Skipped cells emit nothing (a real <td>
		 * upstream has already covered them via rowspan).
		 */
		{
			'HashPostfix': '-TabularTemplate-RowLabel-HeaderCell',
			'Template': /*HTML*/`
									<th class="pict-row-label-header">{~D:Record.Name~}</th>`,
		},
		{
			'HashPostfix': '-TabularTemplate-RowLabel-Cell',
			'Template': /*HTML*/`
									<td rowspan="{~D:Record.RowSpan~}" class="pict-row-label">{~D:Record.RenderedLabel~}</td>`,
		},
		{
			'HashPostfix': '-TabularTemplate-RowLabel-Cell-Skipped',
			'Template': ``,
		},
		/*
		 * END Tabular Template Row Label Columns
		 */

		/*
		 * BEGIN Entry-modal field cells
		 * Used ONLY by the opt-in "add in a dialog" flow
		 * (Group.EntryControls.Mode === 'modal'), which composes a stacked,
		 * labeled one-record template out of the SAME tabular input
		 * metatemplates the grid uses -- see
		 * PictProvider-Bulma-TableControls.buildModalRowTemplate. The grid's own
		 * cell templates emit bare <td>s, which are invalid inside the modal's
		 * <div> and carry no labels (those live in the <th>s), so they cannot be
		 * reused directly the way the RecordSet layout's can.
		 *
		 * NOTE: deliberately no {~D:Record.Macro.HTMLForID~}. That macro resolves
		 * to an id tabular inputs never emit (they use
		 * TABULAR-DATA-{RawHTMLID}-{Key}), so a `for` attribute would dangle.
		 */
		{
			HashPostfix: '-TabularTemplate-ModalCell-Prefix',
			Template: /*HTML*/`
					<div class="column {~EntryModalCellClass:Record~}">
						<label class="label {~HideLabel:Record~} {~HideCheckboxCellLabel:Record~}">{~LabelWithChips:Record:TabularLabel~}</label>
						{~UnitsTabularHeader:Record~}`,
		},
		{
			HashPostfix: '-TabularTemplate-ModalCell-Postfix',
			Template: /*HTML*/`
						<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
					</div>`,
		},
		/*
		 * END Entry-modal field cells
		 */

		{
			HashPostfix: '-TabularTemplate-Row-Prefix',
			Template: /*HTML*/`
								<tr data-tabular-row-index="{~D:Record.Key~}" data-tabular-group-index="{~D:Record.Group~}">
									{~T:TabularTemplateRow-ExtraPrefix~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Cell-Prefix',
			Template: /*HTML*/`
									<td  data-tabular-column-index="{~D:Record.PictForm.InputIndex~}" class="{~HiddenInputTabularAdjustment:Record~}">`,
		},
		{
			HashPostfix: '-TabularTemplate-Cell-Postfix',
			Template: /*HTML*/`
									</td>`,
		},
		{
			HashPostfix: '-TabularTemplate-Row-ExtraPrefix',
			Template: /*HTML*/`
									<!-- TabularTemplateRow-ExtraPrefix -->`,
		},
		{
			HashPostfix: '-TabularTemplate-Row-ExtraPostfix',
			Template: /*HTML*/`
									<!-- TabularTemplateRow-ExtraPostfix -->
									<td class="extra-table-column" data-table-controls="menu">
										<button
											id="TABLE-MENU-BUTTON-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Group~}-{~D:Record.Key~}"
											class="button is-link is-outlined"
											type="button"
											aria-haspopup="true"
											aria-label="Row actions"
											onmouseover="_Pict.providers['Bulma-TableControls'].showMenuForTable(id, '{~D:Context[0].UUID~}', '{~D:Context[0].Hash~}', '{~D:Record.Group~}', '{~D:Record.Key~}', event)"
											onclick="_Pict.providers['Bulma-TableControls'].showMenuForTable(id, '{~D:Context[0].UUID~}', '{~D:Context[0].Hash~}', '{~D:Record.Group~}', '{~D:Record.Key~}', event)">
											<span class="icon is-small">
												<i class="fas fa-ellipsis" aria-hidden="true"></i>
											</span>
										</button>
									</td>`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-ExtraPostfix-TableMenu',
			Template: /*HTML*/`
				<!-- TabularTemplate-RowHeader-ExtraPostfix-TableMenu -->
				<ul class="list-menu">
					<li class="list-menu-item">
						<a class="delete-table-row-button" onclick="_Pict.providers['Bulma-TableControls'].handleTableMenuButtonEvent('Delete', '{~D:Record.UUID~}', '{~D:Record.Hash~}', '{~D:Record.Group~}', '{~D:Record.Key~}')">
							<span class="icon">
								<i class="fas fa-trash" aria-hidden="true"></i>
							</span>
							<span>Delete</span>
						</a>
					</li>
					<li class="list-menu-item">
						<a class="move-table-row-up-button" onclick="_Pict.providers['Bulma-TableControls'].handleTableMenuButtonEvent('MoveUp', '{~D:Record.UUID~}', '{~D:Record.Hash~}', '{~D:Record.Group~}', '{~D:Record.Key~}')">
							<span class="icon">
								<i class="fas fa-arrow-up" aria-hidden="true"></i>
							</span>
							<span>Move Up</span>
						</a>
					</li>
					<li class="list-menu-item">
						<a class="move-table-row-down-button" onclick="_Pict.providers['Bulma-TableControls'].handleTableMenuButtonEvent('MoveDown', '{~D:Record.UUID~}', '{~D:Record.Hash~}', '{~D:Record.Group~}', '{~D:Record.Key~}')">
							<span class="icon">
								<i class="fas fa-arrow-down" aria-hidden="true"></i>
							</span>
							<span>Move Down</span>
						</a>
					</li>
				</ul>`,
		},
		{
			HashPostfix: '-TabularTemplate-Row-Postfix',
			Template: /*HTML*/`
									{~T:TabularTemplateRow-ExtraPostfix~}
								</tr>`,
		},
		{
			HashPostfix: '-TabularTemplate-Group-Postfix',
			Template: /*HTML*/`
								<!-- Form Template Group Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
								<!-- empty message row - auto hidden by CSS -->
								<tr class="table-emtpy-row">
									<td colspan="100%" class="has-text-centered has-text-text-50 p-3">
										<span class="icon">
											<i class="fa fa-fw fa-info-circle"></i>
										</span>
										<span class="icon-text">{~TabularEmptyMessage:Record:No rows have been added.~}</span>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<!-- NOTE: Columns are required here for the flexible scroll slider and add button -->
					<div class="columns is-vcentered is-mobile p-0 m-0 {~HideBottomEntryControls:Record~}">
						<div class="column ml-6 p-0 mb-3">
							<div id="TABLE-SLIDER-WRAPPER-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}" class="field is-hidden" data-table-controls="scroll-slider">
								<input
									id="TABLE-SLIDER-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}"
									class="slider"
									type="range"
									min="0"
									max="100"
									value="0"
									oninput="_Pict.providers['Bulma-TableControls'].updateScrollTableFromSliderEvent('{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}', event)"
									/>
							</div>
						</div>
						<div class="column mx-3 px-0 pt-0 has-text-right is-narrow">
							<button type="button" id="TABLE-TOGGLE-EXTRA-COLUMN-BUTTON-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}"
								data-table-controls="toggle-extra-column"
								class="button is-link is-outlined mr-2 {~HideMenuColumnToggle:Record~}"
								onclick="_Pict.providers['Bulma-TableControls'].handleToggleExtraColumnButtonClickEvents(event, '{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}')">
								<span class="icon">
									<i class="fas fa-eye" aria-hidden="true"></i>
								</span>
								<span> Hide Menu Column</span>
							</button>
							{~EntryModeToggleButton:Record~}
							<button type="button" id="TABLE-ADD-BUTTON-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}"
								data-table-controls="add-row"
								data-max-rows="{~D:Record.MaximumRowCount~}"
								data-min-rows="{~D:Record.MinimumRowCount~}"
								class="button is-link"
								onclick="_Pict.providers['Bulma-TableControls'].handleAddEntryButtonClickEvents(event, '{~D:Context[0].Hash~}', '{~D:Record.GroupIndex~}')">
								<span class="icon">
									<i class="fas fa-plus" aria-hidden="true"></i>
								</span>
								<span> Add new row</span>
							</button>
						</div>
					</div>
				</div>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-TabularTemplate-Group-Prefix',
			DefaultInputExtensions: [ 'Bulma-TableControls' ],
			Template: /*HTML*/`
			<!-- Form Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" class="{~D:Record.CSSClass~}" {~D:Record.Macro.PictFormLayout~}>
				<h3 class="section-subheader has-border {~ShowGroupTitle:Record~}" data-i-group-hash="{~D:Record.Hash~}">{~D:Record.Name~}</h3>
				<div class="section-table-wrapper mb-2 {~HideTableControls:Record~}">
					<div id="TABLE-WRAPPER-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}" class="table-container"
						onscroll="_Pict.providers['Bulma-TableControls'].updateSliderFromScrollTableEvent('{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}', event)">
						<table id="TABLE-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}" class="table is-fullwidth is-hoverable">`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-Prefix',
			Template: /*HTML*/`
							<thead>
								<tr>
									{~T:TabularTemplateRowHeader-ExtraPrefix~}`,
		},
		{
			HashPostfix: '-TabularTemplate-HeaderCell',
			Template: /*HTML*/`
									<!-- Descriptor {~D:Record.Name~} [{~D:Record.Hash~}] -> {~D:Record.Address~} -->
									<th data-tabular-column-index="{~D:Record.PictForm.InputIndex~}" class="{~HiddenInputTabularAdjustment:Record~}">
										<span class="label {~HideLabel:Record~}">{~LabelWithChips:Record:TabularLabel~}</span>
										{~UnitsTabularHeader:Record~}
									</th>`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-ExtraPrefix',
			Template: /*HTML*/`
									<!-- TabularTemplateRowHeader-ExtraPrefix -->`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-ExtraPostfix',
			Template: /*HTML*/`
									<!-- TabularTemplateRowHeader-ExtraPostfix -->`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-Postfix',
			Template: /*HTML*/`
									{~T:TabularTemplateRowHeader-ExtraPostfix~}
								</tr>
							</thead>
							<tbody>`,
		},
		{
			HashPostfix: '-TabularTemplate-Row-Prefix',
			Template: /*HTML*/`
								<tr data-tabular-row-index="{~D:Record.Key~}" data-tabular-group-index="{~D:Record.Group~}">
									{~T:TabularTemplateRow-ExtraPrefix~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Cell-Prefix',
			Template: /*HTML*/`
									<td data-tabular-column-index="{~D:Record.PictForm.InputIndex~}" class="{~HiddenInputTabularAdjustment:Record~}">`,
		},
		{
			HashPostfix: '-TabularTemplate-Cell-Postfix',
			Template: /*HTML*/`
									</td>`,
		},
		{
			HashPostfix: '-TabularTemplate-Row-ExtraPrefix',
			Template: /*HTML*/`
									<!-- TabularTemplateRow-ExtraPrefix -->`,
		},
		{
			HashPostfix: '-TabularTemplate-Row-ExtraPostfix',
			Template: /*HTML*/`
									<!-- TabularTemplateRow-ExtraPostfix -->`,
		},
		{
			HashPostfix: '-TabularTemplate-Row-Postfix',
			Template: /*HTML*/`
									{~T:TabularTemplateRow-ExtraPostfix~}
								</tr>`,
		},
		{
			HashPostfix: '-TabularTemplate-Group-Postfix',
			Template: /*HTML*/`
								<!-- Form Template Group Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
								<!-- empty message row - auto hidden by CSS -->
								<tr class="table-emtpy-row">
									<td colspan="100%" class="has-text-centered has-text-text-50 p-3">
										<span class="icon">
											<i class="fa fa-fw fa-info-circle"></i>
										</span>
										<span class="icon-text">{~TabularEmptyMessage:Record:No data available.~}</span>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<!-- NOTE: Columns are required here for the flexible scroll slider and add button -->
					<div class="columns is-vcentered is-mobile m-0 p-0">
						<div class="column ml-6 p-0 mb-3">
							<div id="TABLE-SLIDER-WRAPPER-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}" class="field is-hidden">
								<input
									id="TABLE-SLIDER-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}"
									class="slider"
									type="range"
									min="0"
									max="100"
									value="0"
									oninput="_Pict.providers['Bulma-TableControls'].updateTableControlsFromSliderEvent('{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}', event)"
									/>
							</div>
						</div>
					</div>
				</div>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-TabularTemplate-Group-Prefix',
			DefaultInputExtensions: [ 'Bulma-TableControls' ],
			Template: /*HTML*/`
			<!-- Form Template Group Prefix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
			<div id="GROUP-{~D:Context[0].formID~}-{~D:Record.Hash~}" class="{~D:Record.CSSClass~} {~HideInPDF:Record~}" {~D:Record.Macro.PictFormLayout~}>
				<h3 class="section-subheader has-border {~ShowGroupTitle:Record~}" data-i-group-hash="{~D:Record.Hash~}">{~D:Record.Name~}</h3>
				<!-- NOTE: We preserve the overflow behavior of the table container to prevent PDFs from becoming distorted - wide tables will need to provide an alternate print layout -->
				<div id="TABLE-WRAPPER-FOR-{~D:Context[0].UUID~}-{~D:Context[0].Hash~}-{~D:Record.Hash~}" class="table-container mb-2">
					<table class="table is-fullwidth is-hoverable">`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-Prefix',
			Template: /*HTML*/`
						<thead>
							<tr>
								{~T:TabularTemplateRowHeader-ExtraPrefix~}`,
		},
		{
			HashPostfix: '-TabularTemplate-HeaderCell',
			Template: /*HTML*/`
								<!-- Descriptor {~D:Record.Name~} [{~D:Record.Hash~}] -> {~D:Record.Address~} -->
								<th data-tabular-column-index="{~D:Record.PictForm.InputIndex~}" class="{~HiddenInputTabularAdjustment:Record~}" style="vertical-align: bottom">
									{~LabelWithChips:Record~}
									{~UnitsTabularHeader:Record~}
								</th>`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-ExtraPrefix',
			Template: /*HTML*/`
								<!-- TabularTemplateRowHeader-ExtraPrefix -->`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-ExtraPostfix',
			Template: /*HTML*/`
								<!-- TabularTemplateRowHeader-ExtraPostfix -->`,
		},
		{
			HashPostfix: '-TabularTemplate-RowHeader-Postfix',
			Template: /*HTML*/`
								{~T:TabularTemplateRowHeader-ExtraPostfix~}
							</tr>
						</thead>
						<tbody>`,
		},
		{
			HashPostfix: '-TabularTemplate-Row-Prefix',
			Template: /*HTML*/`
							<tr data-tabular-row-index="{~D:Record.Key~}" data-tabular-group-index="{~D:Record.Group~}">
								{~T:TabularTemplateRow-ExtraPrefix~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Cell-Prefix',
			Template: /*HTML*/`
								<td data-tabular-column-index="{~D:Record.PictForm.InputIndex~}" class="is-vcentered {~HiddenInputTabularAdjustment:Record~}">`,
		},
		{
			HashPostfix: '-TabularTemplate-Cell-Postfix',
			Template: /*HTML*/`
								</td>`,
		},
		{
			HashPostfix: '-TabularTemplate-Row-ExtraPrefix',
			Template: /*HTML*/`
								<!-- TabularTemplateRow-ExtraPrefix -->`,
		},
		{
			HashPostfix: '-TabularTemplate-Row-ExtraPostfix',
			Template: /*HTML*/`
								<!-- TabularTemplateRow-ExtraPostfix -->`,
		},
		{
			HashPostfix: '-TabularTemplate-Row-Postfix',
			Template: /*HTML*/`
								{~T:TabularTemplateRow-ExtraPostfix~}
							</tr>`,
		},
		{
			HashPostfix: '-TabularTemplate-Group-Postfix',
			Template: /*HTML*/`
							<!-- Form Template Group Postfix [{~D:Context[0].UUID~}]::[{~D:Context[0].Hash~}] {~D:Record.Hash~}::{~D:Record.Name~} -->
							<!-- empty message row - auto hidden by CSS -->
							<tr class="table-emtpy-row">
								<td colspan="100%" class="has-text-centered has-text-text-50 p-3">
									<span class="icon">
										<i class="fa fa-fw fa-info-circle"></i>
									</span>
									<span class="icon-text">{~TabularEmptyMessage:Record:No data available.~}</span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
